<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  #multiSelectComponent
  [options]="nomenclatures"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [(selectedItems)]="selectedNomenclatures"
  (selectedItemsChange)="selectedNomenclaturesChange.emit($event)"
  (openedChange)="openedChange.emit($event)"
  [label]="isFloatLabel ? label : ''"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled || groupsDisabled"
  [showClear]="showClear"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [itemStyleClass]="'crm-nomenclature-multi-select-item'"
  [panelStyleClass]="'crm-nomenclature-multi-select-panel'">
</crm-multi-select>
